module.exports = __webpack_public_path__ + "img/er.a22cdf5b.svg";